import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "f-field-group__items" }

import { computed, inject } from 'vue';
import {
  FormFieldGroupEmits,
  FormFieldGroupProps,
  FormFieldGroupRef,
} from '@/types/form/form-field-group';
import { DynamicFormField } from '@/types/form/dynamic-form';
import utils from '@/utils';
import { ScItem } from '@/types/sitecore';
import useDevice from '@/hooks/useDevice';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormFieldGroup',
  props: {
    item: {},
    onChange: { type: Function }
  },
  emits: ["register", "change", "iconClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { largeThanTablet } = useDevice();

const fields = computed(() => props.item?.fields);
const items = computed(() => fields.value?.items ?? []);
const hasItems = computed(() => items.value.length > 0);

const desktopColumnLayout = computed(() => {
  let val = utils.sp.getVal(fields.value?.desktopColumnLayout);
  if (!val) val = '2';
  const num = Number(val);
  if (isNaN(num)) return val;
  return `repeat(${num}, 1fr)`;
});
const rootStyle = computed(() => {
  if (largeThanTablet && desktopColumnLayout.value) {
    return {
      '--column-layout': desktopColumnLayout.value,
    };
  }
  return {};
});

const getComponentType = (item: ScItem<DynamicFormField>) => {
  const fieldType = utils.sp.getVal(item?.fields?.fieldType);
  return fieldType ?? 'FormInput';
};

const onIconClick = (iconKey: string, value: string) => {
  emit('iconClick', iconKey, value);
};

const onChange = (fieldType: string, fieldName: string, value: any, originValue?: any) => {
  emit('change', fieldType, fieldName, value, originValue);
};

return (_ctx: any,_cache: any) => {
  return (hasItems.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "f-field-group",
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentType(item)), {
              key: `${item.id}-${index}`,
              item: item,
              onIconClick: onIconClick,
              onChange: onChange,
              class: "f-field-group__item"
            }, null, 40, ["item"]))
          }), 128))
        ])
      ], 4))
    : _createCommentVNode("", true)
}
}

})